var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-column-skeleton"},[_c('div',{staticClass:"chart-box"},[_vm._l((_vm.cols),function(key){return [_c('div',{key:key,staticClass:"chart-column",style:([{height: `${Math.random() * 100}%`}])})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }